import React from "react";
import { TrainingSessionCard } from "./styles/rctp-styles";
import { TitleMed } from "components/rhombus-UI/theme/typography";
import RhombusButton from "components/common/RhombusButton";
import { Body, TitleSmall } from "components/rui/typography";
import { FlexColumn, FlexRowCenter } from "components/rui/layout";
import { formatRctpDate } from "./util/rctp-functions";
import IconMapPin from "components/common/icon-components/IconMapPin";

const TrainingEvent = ({ eventData }) => {
  const trainingSession = eventData.node.frontmatter;

  return (
    <TrainingSessionCard className="card">
      <img src={trainingSession.image} alt="training session" />
      <div className="card-inner">
        <FlexColumn gap="1.25rem">
          <FlexColumn>
            <TitleMed light fontSize="28px">
              {trainingSession.title}
            </TitleMed>
            <Body light>
              {formatRctpDate(trainingSession.dateRange.start, "LLL, d, yyyy")}
            </Body>
            <Body light className="txt-small">
              {formatRctpDate(trainingSession.dateRange.start, "h:mma")}-
              {formatRctpDate(trainingSession.dateRange.end, "h:mma")}
            </Body>
          </FlexColumn>
          <FlexColumn className="hide" gap="0.25rem">
            <FlexRowCenter gap="0.25rem">
              <IconMapPin color="var(--white)" size="14" />
              <TitleSmall light>ADDRESS</TitleSmall>
            </FlexRowCenter>
            <Body light>{trainingSession.address}</Body>
          </FlexColumn>
        </FlexColumn>
        <RhombusButton
          useHref
          target={"_blank"}
          type="primary-light"
          title="Reserve Your Spot"
          path={trainingSession.link}
        />
      </div>
    </TrainingSessionCard>
  );
};

export default TrainingEvent;
